import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardTitle } from 'components/shadcn/ui/card';
import { useVerifyAdmin, useVerifyCustomer } from 'helper';
import { HGTable } from '../../components/HGTable';
import { Button } from 'components/shadcn/ui/button';
import { PlusIcon } from '@heroicons/react/20/solid';
import './index.css';
import { useGetSites, useColumns } from './helper';
import { PAGE_SIZE } from './constants';

export const Sites = () => {
    const isAdmin = useVerifyAdmin();
    const isCustomer = useVerifyCustomer();
    const searchSetting = JSON.parse(sessionStorage.getItem('searchSettings'));
    const [filterBy, setFilterBy] = useState(() => {
        return searchSetting?.sites?.filterBy ?? '';
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState('');
    const [sortField, setSortField] = useState(() => {
        return searchSetting?.sites?.sort ?? '';
    });
    const [sortDirection, setSortDirection] = useState(-1);
    const { data, isFetching } = useGetSites(
        filterBy,
        search,
        sortField,
        sortDirection,
        currentPage
    );
    const columns = useColumns();

    // persist filterBy and sortField to session storage whenever they change
    useEffect(() => {
        const lastFilter =
            JSON.parse(sessionStorage.getItem('searchSettings')) ?? {};
        sessionStorage.setItem(
            'searchSettings',
            JSON.stringify({
                ...lastFilter,
                sites: { filterBy, sort: sortField },
            })
        );
    }, [filterBy, sortField]);

    return (
        <Card>
            <CardHeader>
                <CardTitle className="flex justify-between gap-2 text-primary-foreground">
                    Sites
                    {!isCustomer && (
                        <Button
                            variant="outline"
                            size="sm"
                            className="capitalize"
                            onClick={() => {
                                window.location.href = '/sites/add-site';
                            }}
                        >
                            <PlusIcon className="h-5 w-5" />
                            site
                        </Button>
                    )}
                </CardTitle>
            </CardHeader>
            <HGTable
                data={data?.sites ?? []}
                columns={columns}
                rowsHref={(item) => `/${item.SiteLink}`}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                filterBy={filterBy}
                setFilterBy={setFilterBy}
                sortField={sortField}
                setSortField={setSortField}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                loading={isFetching}
                skeletonRows={20}
                search={search}
                setSearch={setSearch}
                canFilter={isAdmin}
                canSearch={isAdmin}
                pageSize={PAGE_SIZE}
                totalItems={data?.total ?? 0}
                onSearchChange={(value) => {
                    setSearch(value);
                    setCurrentPage(1); // Reset to first page on search
                }}
            />
        </Card>
    );
};
